import * as React from 'react'

import {applyTheme, classNames} from '@base/react-utils'

import TextInput from './TextInput'
import type {TextInputProps} from './TextInput'

import baseTheme from './InlineTextInput.css'

type InlineTextInputProps = TextInputProps & {
  textAlign?: 'left' | 'center' | 'right' | 'justify'
  color?: 'default' | 'invert' | 'inherit'
}

export default function InlineTextInput(props: InlineTextInputProps) {
  const theme = applyTheme(baseTheme, props.theme)
  const className = classNames(
    theme[`textAlign_${props.textAlign || 'left'}`],
    theme[`color_${props.color || 'default'}`],
    props.className
  )
  return (
    <TextInput
      {...props}
      className={className}
      theme={theme}
      width={props.width || 'static'}
    />
  )
}

InlineTextInput.displayName = 'InlineTextInput'
